import axios from "axios";

const API = window.location.origin;

export function getToken() {
  return localStorage.getItem("auth_token");
}

export function setToken(t) {
  if (t) localStorage.setItem("auth_token", t);
}

// Guncel token ile Authorization header (her cagri aninda taze okunur)
export function authHeaders() {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

// JWT exp'ini client-side oku (imza DOGRULAMASI YOK, sadece zamanlama tahmini icin)
export function tokenExpMs(tok) {
  try {
    const p = JSON.parse(atob((tok || "").split(".")[1] || ""));
    return (p.exp || 0) * 1000;
  } catch {
    return 0;
  }
}

// Token yok / cozulemiyor / son 60sn -> yenilenmeli
export function isTokenExpiring(tok, skewMs = 60000) {
  const exp = tokenExpMs(tok);
  if (!exp) return true;
  return Date.now() > exp - skewMs;
}

let _refreshPromise = null;

// Tek-ucus (single-flight) access token yenileme. httpOnly refresh_token cookie kullanir.
// Basarili -> yeni access token (string). Basarisiz -> null.
export function refreshAccessToken() {
  if (!_refreshPromise) {
    _refreshPromise = axios
      .post(`${API}/api/auth/refresh`, {}, { withCredentials: true })
      .then(({ data }) => {
        if (data && data.token) {
          setToken(data.token);
          return data.token;
        }
        return null;
      })
      .catch(() => null)
      .finally(() => {
        _refreshPromise = null;
      });
  }
  return _refreshPromise;
}
